<template>
  <div v-if="!isImageMode">
    <div class="globe">
      <img src="@/assets/images/Ruler.png" alt="ruler">
      <img
        title="globe" src="@/assets/images/Globe.png"
        alt="globe"
      >
    </div>
    <div class="right_icons">
      <button type="button" @click="LicenseModalToggle"><img src="@/assets/images/PolicyIcon.png" alt="PolicyIcon">
      </button>
      <img src="@/assets/images/EnergyIcon.png" alt="energyIcon">
      <img src="@/assets/images/SatIcon.png" alt="satIcon">
      <img src="@/assets/images/AntennaIcon.png" alt="antennaIcon">
    </div>
    <div class="bottom_text">
      <div class="bottom_text_left">
        <p class="bottom_text_bold">
          OREUM SAT
        </p>
        <p class="bottom_text_regular">
          Microsatellite for Earth Observation<br />and FSO Communication
        </p>
      </div>
      <div class="bottom_text_center">
        <p class="bottom_text_bold">
          COPY RIGHT
        </p>
        <p class="bottom_text_regular">
          CONTEC Co., Ltd. all right reserved
        </p>
      </div>
      <div class="bottom_text_right">
        <p class="bottom_text_bold">
          LAUNCH INFO
        </p>
        <p class="bottom_text_regular">CALIFORNIA. Vandenberg Space Force Base<br />SPACE X TR-10 / SLC-4E launch pad
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import useCommonStore from '@/store/storeCommon';

const { isImageMode } = storeToRefs(useCommonStore());
const { LicenseModalToggle } = useCommonStore();
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.globe {
  display: flex;
  flex-direction: column;
  gap: 7.6px;
  position: fixed;
  top: 65.6px;
  right: 51px;
  z-index: 1;

  img {
    width: 97.6px;
  }
}

.right_icons {
  width: 35.6px;
  display: flex;
  flex-direction: column;
  gap: 17.2px;
  position: fixed;
  bottom: 35.7px;
  right: 51px;
  z-index: 200;

  > img {
    opacity: 0.6;
  }

  button {
    width: 35.6px;


    img {
      width: 100%;
    }
  }
}

.bottom_text {
  width: 82%;
  color: $color-debra;
  display: flex;
  justify-content: space-between;
  position: fixed;
  left: 50%;
  bottom: 35px;
  transform: translateX(-50%);
  z-index: 1;

  > div {
    width: 220px;
  }

  &_left {
    text-align: left;
  }

  &_center {
    text-align: center;
  }

  &_right {
    text-align: right;
  }

  &_bold {
    font-family: "Poppins ExtraBold 800", serif;
    font-size: 13px;
    line-height: 1.54;
  }

  &_regular {
    font-family: "Poppins Medium 500", serif;
    font-size: 10px;
    line-height: 1.3;
  }
}

// pc
@media (min-width: 1921px) {
  .bottom_text {
    width: 90%;
  }
}
</style>